import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@shared/ui';
import React from 'react';

export interface ShareConfirmationDialogProps {
  open: boolean;
  memberName: string;
  sessionDate: string;
  version: number;
  onClose: () => void;
  onConfirm: () => void;
  isSharing?: boolean;
  error?: string | null;
}

export const ShareConfirmationDialog: React.FC<ShareConfirmationDialogProps> = ({
  open,
  memberName,
  sessionDate,
  version,
  onClose,
  onConfirm,
  isSharing = false,
  error = null,
}) => {
  const normalizedSessionDate = sessionDate.trim().toLowerCase();
  const sessionPhrase =
    normalizedSessionDate === '' ||
    normalizedSessionDate === 'this' ||
    normalizedSessionDate === 'this session'
      ? 'this session'
      : `the ${sessionDate.trim()} session`;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontWeight: 'bold', pb: 1 }}>Share with {memberName}</DialogTitle>
      <DialogContent sx={{ pb: 3 }}>
        <Typography variant="body1" color="text.secondary">
          Sharing coaching session summary (v{version}) for {sessionPhrase}.
        </Typography>
        {error && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {error}
          </Alert>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button color="gray" variant="outlined" onClick={onClose} disabled={isSharing}>
          Cancel
        </Button>
        <Button color="primary" variant="contained" onClick={onConfirm} disabled={isSharing}>
          {isSharing ? 'Sharing...' : 'Share'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ShareConfirmationDialog;
